/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id="' + id + '"]');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      // Next page to request (page 1 is already in the DOM).
      this.i = 2;
      this.observer = null;
      this.totalPages = Number(this.dataset.totalPages) || Infinity;
    }
    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
    }
    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
    complete() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      this.removeAttribute('loading');
      if (this.button) {
        this.button.classList.add('visually-hidden');
      }
    }
    addUrlParam(search, key) {
      var newParam = key + '=' + this.i,
        params = '?' + newParam;

      // If the "search" string exists, then build params from it
      if (search) {
        // Try to replace an existance instance
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }
    loadMore() {
      let base = this;
      this.button.addEventListener('click', function () {
        base.loadProducts();
        this.blur();
        return false;
      });
    }
    infinite() {
      let base = this;
      if (base.observer) {
        base.observer.disconnect();
      }
      // isIntersecting + rootMargin is more stable than requiring ratio === 1,
      // which flickers when lazy images / appended rows shift layout.
      base.observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          base.loadProducts();
        }
      }, {
        root: null,
        rootMargin: '200px 0px',
        threshold: 0
      });
      base.observer.observe(base);
    }
    loadProducts() {
      let base = this,
        url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
      if (base.i > base.totalPages) {
        base.complete();
        return;
      }
      if (base.getAttribute('loading')) {
        return;
      }
      base.setAttribute('loading', true);
      // Pause observation while a page is in flight to avoid stacked fetches
      // when the sentinel stays visible through layout shifts.
      if (base.observer) {
        base.observer.unobserve(base);
      }
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          base.renderProducts(html, url);

          dispatchCustomEvent('pagination:page-changed', {
            url: url
          });
        })
        .catch((error) => {
          console.error('Pagination fetch failed', error);
          base.removeAttribute('loading');
          if (base.observer) {
            base.observer.observe(base);
          }
        });
    }
    renderProducts(html, url) {
      let base = this,
        grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');

      if (!grid_to_replace) {
        base.complete();
        return;
      }
      let products = grid_to_replace.querySelectorAll('.column');

      if (!products.length) {
        base.complete();
        return;
      }

      for (var i = 0; i < products.length; i++) {
        this.grid.appendChild(products[i]);
        products[i].querySelectorAll('.lazyload').forEach((image) => {
          lazySizes.loader.unveil(image);
        });
      }

      // Advance page only after a successful append so retries do not skip pages.
      base.i++;

      // Treat loading as fetch-in-flight only. Do not wait on GSAP — if onComplete
      // never fires, unobserve would leave infinite scroll permanently stuck.
      base.removeAttribute('loading');

      if (this.animations_enabled) {
        gsap.set(products, {
          opacity: 0,
          y: 30
        });
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05
        });
      }

      if (base.i > base.totalPages) {
        base.complete();
        return;
      }
      if (base.observer) {
        base.observer.observe(base);
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
}
